import { SearchRequestContent } from "common/types";
import { SearchResponseContent } from "common/types/search-types";

import { SearchExperienceService } from "./shop-search-service";

export interface ISearchService {
  Search(parameters: SearchRequestContent): Promise<SearchResponseContent>;
}

export async function createSearchService(): Promise<ISearchService> {
  // Using Catalogical
  return new SearchExperienceService("software");
}
